'use strict';

exports.__esModule = true;

var _FORMAT_RULE;

/*--------------------------
    Variable
--------------------------*/

// 支援的 format 按鈕
var FORMAT_TYPE = {
    BOLD: 'bold',
    ITALIC: 'italic',
    STRIKETHROUGH: 'strikethrough',
    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    QUOTE: 'quote',
    OLIST: 'oList',
    ULIST: 'uList'
};

var FORMAT_RULE = (_FORMAT_RULE = {}, _FORMAT_RULE[FORMAT_TYPE.BOLD] = {
    type: 'inline',
    token: 'strong',
    before: '**',
    after: '**',
    placeholder: 'bold'
}, _FORMAT_RULE[FORMAT_TYPE.ITALIC] = {
    type: 'inline',
    token: 'em',
    before: '_',
    after: '_',
    placeholder: 'italic'
}, _FORMAT_RULE[FORMAT_TYPE.STRIKETHROUGH] = {
    type: 'inline',
    token: 'strikethrough',
    before: '~~',
    after: '~~',
    placeholder: 'strikethrough'
}, _FORMAT_RULE[FORMAT_TYPE.H1] = {
    type: 'block',
    token: 'header-1',
    before: '#',
    re: /^#\s+/,
    placeholder: 'Header'
}, _FORMAT_RULE[FORMAT_TYPE.H2] = {
    type: 'block',
    token: 'header-2',
    before: '##',
    re: /^##\s+/,
    placeholder: 'Header'
}, _FORMAT_RULE[FORMAT_TYPE.H3] = {
    type: 'block',
    token: 'header-3',
    before: '###',
    re: /^###\s+/,
    placeholder: 'Header'
}, _FORMAT_RULE[FORMAT_TYPE.QUOTE] = {
    type: 'block',
    token: 'quote',
    re: /^\>\s+/,
    before: '>',
    placeholder: 'Quote'
}, _FORMAT_RULE[FORMAT_TYPE.OLIST] = {
    type: 'block',
    before: '1. ',
    re: /^\d+\.\s+/,
    placeholder: 'List'
}, _FORMAT_RULE[FORMAT_TYPE.ULIST] = {
    type: 'block',
    before: '* ',
    re: /^[\*\-]\s+/,
    placeholder: 'List'
}, _FORMAT_RULE);

var FORMAT_TOKENS = {};
Object.keys(FORMAT_RULE).forEach(function (key) {
    var rule = FORMAT_RULE[key];

    if (rule.token) {
        FORMAT_TOKENS[rule.token] = key;
    }
});

var CODE_SYNTAX = {
    DEFAULT: '',
    PYTHON: 'python',
    JULIA: 'julia',
    JAVA: 'java',
    CSHARP: 'csharp',
    C: 'c',
    CPP: 'cpp',
    OBJC: 'objc',
    JS: 'js',
    JSON: 'json',
    HTML: 'html',
    XML: 'xml',
    CSS: 'css',
    SCSS: 'scss'
};

var CODE_SYNTAX_TOKENS = {};
Object.keys(CODE_SYNTAX).forEach(function (key) {
    var code = CODE_SYNTAX[key];
    CODE_SYNTAX_TOKENS[code] = key;
});

var FONT_SIZE = [12, 13, 14, 15, 16, 17, 18, 24, 30];

var FONT_COLORS = ['#333333', '#434343', '#666666', '#999999', '#b7b7b7', '#cccccc', '#d9d9d9', '#efefef', '#f3f3f3', '#ffffff', '#980000', '#ff0000', '#ff9900', '#ffff00', '#00ff00', '#00ffff', '#15a5ff', '#0000ff', '#9900ff', '#ff00ff', '#e6b8af', '#f4cccc', '#fce5cd', '#fff2cc', '#d9ead3', '#d0e0e3', '#c9daf8', '#cfe2f3', '#d9d2e9', '#ead1dc', '#dd7e6b', '#ea9999', '#f9cb9c', '#ffe599', '#b6d7a8', '#a2c4c9', '#a4c2f4', '#9fc5e8', '#b4a7d6', '#d5a6bd', '#cc4125', '#e06666', '#f6b26b', '#ffd966', '#93c47d', '#76a5af', '#6d9eeb', '#6fa8dc', '#8e7cc3', '#c27ba0', '#a61c00', '#cc0000', '#e69138', '#f1c232', '#6aa84f', '#45818e', '#3c78d8', '#3d85c6', '#674ea7', '#a64d79', '#85200c', '#990000', '#b45f06', '#bf9000', '#38761d', '#134f5c', '#1155cc', '#0b5394', '#351c75', '#741b47', '#5b0f00', '#660000', '#783f04', '#7f6000', '#274e13', '#0c343d', '#1c4587', '#073763', '#20124d', '#4c1130'];

/*--------------------------
    Method
--------------------------*/

// ------------------------------
// 取得游標位置狀態
// ------------------------------
function getCursorState(codemirror, posistion) {

    posistion = posistion || codemirror.getCursor('start');

    var cursorState = {};
    var token = cursorState.token = codemirror.getTokenAt(posistion);
    if (!token.type) {
        return cursorState;
    }

    var tokens = token.type.split(' ');

    tokens.forEach(function (_token) {

        if (FORMAT_TOKENS[_token]) {
            cursorState[FORMAT_TOKENS[_token]] = true;
            return;
        }

        switch (_token) {
            // case 'link':
            // 	cursorState.link = true;
            // 	cursorState.link_label = true;
            //     break;
            // case 'string':
            // 	cursorState.link = true;
            // 	cursorState.link_href = true;
            //     break;
            case 'variable-2':
                var text = codemirror.getLine(posistion.line);

                if (/^\s*\d+\.\s/.test(text)) {
                    cursorState[FORMAT_TYPE.OLIST] = true;
                } else {
                    cursorState[FORMAT_TYPE.ULIST] = true;
                }
                break;
        }
    });

    return cursorState;
}

// ------------------------------
// format 格式按鈕按下時
// ------------------------------
function applyFormat(codemirror, key) {

    var cursorState = getCursorState(codemirror);
    var format = FORMAT_RULE[key];

    if (!format) {
        return;
    }

    var isActive = cursorState[key];

    switch (format.type) {
        case 'inline':
            isActive ? inlineRemove(codemirror, format) : inlineApply(codemirror, format);
            break;
        case 'block':
            isActive ? blockRemove(codemirror, format) : blockApply(codemirror, format);
            break;
        default:
            break;
    }
}

// ------------------------------
// inlineApply
// ------------------------------
function inlineApply(codemirror, format) {

    var startPoint = codemirror.getCursor('start');
    var endPoint = codemirror.getCursor('end');
    var text = codemirror.getSelection() || format.placeholder;

    codemirror.replaceSelection(format.before + text + format.after);

    startPoint.ch += format.before.length;
    endPoint.ch += format.after.length;

    codemirror.setSelection(startPoint, endPoint);
    codemirror.focus();
}

// ------------------------------
// inlineRemove
// ------------------------------
function inlineRemove(codemirror, format) {

    var startPoint = codemirror.getCursor('start');
    var endPoint = codemirror.getCursor('end');
    var line = codemirror.getLine(startPoint.line);

    var startPos = startPoint.ch;
    while (startPos) {
        if (line.substr(startPos, format.before.length) === format.before) {
            break;
        }
        startPos--;
    }

    var endPos = endPoint.ch;
    while (endPos <= line.length) {
        if (line.substr(endPos, format.after.length) === format.after) {
            break;
        }
        endPos++;
    }

    var start = line.slice(0, startPos);
    var mid = line.slice(startPos + format.before.length, endPos);
    var end = line.slice(endPos + format.after.length);
    codemirror.replaceRange(start + mid + end, { line: startPoint.line, ch: 0 }, { line: startPoint.line, ch: line.length + 1 });
    codemirror.setSelection({ line: startPoint.line, ch: start.length }, { line: startPoint.line, ch: (start + mid).length });
    codemirror.focus();
}

// ------------------------------
// blockApply
// ------------------------------
function blockApply(codemirror, format) {

    var startPoint = codemirror.getCursor('start');
    var line = codemirror.getLine(startPoint.line);
    var text = format.before + ' ' + (line.length ? line : format.placeholder);
    codemirror.replaceRange(text, { line: startPoint.line, ch: 0 }, { line: startPoint.line, ch: line.length + 1 });
    codemirror.setSelection({ line: startPoint.line, ch: format.before.length + 1 }, { line: startPoint.line, ch: text.length });
    codemirror.focus();
}

// ------------------------------
// blockRemove
// ------------------------------
function blockRemove(codemirror, format) {

    var startPoint = codemirror.getCursor('start');
    var line = codemirror.getLine(startPoint.line);
    var text = line.replace(format.re, '');
    codemirror.replaceRange(text, { line: startPoint.line, ch: 0 }, { line: startPoint.line, ch: line.length + 1 });
    codemirror.setSelection({ line: startPoint.line, ch: 0 }, { line: startPoint.line, ch: text.length });
    codemirror.focus();
}

// ------------------------------
// 加入文字
// ------------------------------
function insertInlineText(codemirror, text) {

    var startPoint = codemirror.getCursor('start');
    var endPoint = codemirror.getCursor('end');

    codemirror.replaceSelection(text + codemirror.getSelection());

    startPoint.ch += text.length;
    endPoint.ch += text.length;
    codemirror.setSelection(startPoint, endPoint);
    codemirror.focus();
}

// ------------------------------
// 加入程式碼
// ------------------------------
function insertCodeblock(codemirror, codeSyntax) {

    var startPoint = codemirror.getCursor('start');
    var endPoint = codemirror.getCursor('end');

    var new_startPoint = {
        ch: startPoint.ch,
        line: startPoint.line
    };

    var new_endPoint = {
        ch: endPoint.ch,
        line: endPoint.line
    };

    // 只提供支援的程式碼
    var isSupport = checkIsSupportCode(codeSyntax);

    if (!isSupport) {
        codeSyntax = CODE_SYNTAX.DEFAULT;
    }

    var text = codemirror.getSelection();

    var isFirstCh = startPoint.ch === 0;
    var isEmpty = !text;

    if (isEmpty) {
        text = 'enter code here';
        new_endPoint.ch += text.length;
    }

    var before = "```" + codeSyntax + "\n";
    var after = "\n```";

    new_startPoint.ch = 0;
    new_startPoint.line += 1;
    new_endPoint.line += 1;

    if (!isFirstCh) {
        before = "\n" + before;
        new_startPoint.line += 1;
        new_endPoint.line += 1;
    }

    codemirror.replaceSelection(before + text + after);
    codemirror.setSelection(new_startPoint, new_endPoint);
    codemirror.focus();
}

// ------------------------------
// 是否是支援的程式碼
// ------------------------------
function checkIsSupportCode(codeSyntax) {

    var code = CODE_SYNTAX_TOKENS[codeSyntax];

    return !!code;
}

// ------------------------------
// 開始不記錄操作記錄(undo/redo)
//
// !!!!!! 注意 !!!!!!
// 呼叫這個 method 後，一定要呼叫 endOperation，不然編輯器就會無法再更新
// ------------------------------
function startOperation(codemirror) {

    codemirror.startOperation();
}

// ------------------------------
// 結束不記錄操作記錄(undo/redo)
// ------------------------------
function endOperation(codemirror) {

    codemirror.endOperation();
}

// ------------------------------
// 替換編輯器內的文字
// ------------------------------
function replaceText(codeMirror, oriText, newText) {

    var cursor = codeMirror.getSearchCursor(oriText);

    while (cursor.findNext()) {
        cursor.replace(newText);
    }
}

// ------------------------------
// 加入數學式
// ------------------------------
function insertLatex(codemirror, isBlock) {

    var startPoint = codemirror.getCursor('start');
    var endPoint = codemirror.getCursor('end');

    var new_startPoint = {
        ch: startPoint.ch,
        line: startPoint.line
    };

    var new_endPoint = {
        ch: endPoint.ch,
        line: endPoint.line
    };

    var text = codemirror.getSelection();

    var isFirstCh = startPoint.ch === 0;
    var isEmpty = !text;

    if (isEmpty) {
        text = '\\sqrt{x^2+y^2}';
        new_endPoint.ch += text.length;
    }

    var before = void 0;
    var after = void 0;

    if (isBlock) {
        before = "$$$$\n";
        after = "\n$$$$";

        new_startPoint.ch = 0;
        new_startPoint.line += 1;
        new_endPoint.line += 1;

        if (!isFirstCh) {
            before = "\n" + before;
            new_startPoint.line += 1;
            new_endPoint.line += 1;
        }
    } else {
        before = "$$ ";
        after = " $$";

        new_startPoint.ch += 3;
        new_endPoint.ch += 3;
    }

    codemirror.replaceSelection(before + text + after);
    codemirror.setSelection(new_startPoint, new_endPoint);
    codemirror.focus();
}

// ------------------------------
// 加入表格
// ------------------------------
function insertTable(codemirror) {

    var startPoint = codemirror.getCursor('start');
    var endPoint = codemirror.getCursor('end');

    var new_startPoint = {
        ch: startPoint.ch,
        line: startPoint.line
    };

    var new_endPoint = {
        ch: endPoint.ch,
        line: endPoint.line
    };

    var table = '\n| header | header |\n' + '| ------ | ------ |\n' + '| cell | cell |\n' + '| cell | cell |\n';

    new_startPoint.ch = 0;
    new_startPoint.line += 1;
    new_endPoint.line += 1;

    codemirror.replaceSelection(table);
    codemirror.setSelection(new_startPoint, new_endPoint);
    codemirror.focus();
}

// ------------------------------
// 加入可折疊區塊
// ------------------------------
function insetCollapsibleSection(codemirror) {

    var startPoint = codemirror.getCursor('start');
    var endPoint = codemirror.getCursor('end');

    var new_startPoint = {
        ch: startPoint.ch,
        line: startPoint.line
    };

    var new_endPoint = {
        ch: endPoint.ch,
        line: endPoint.line
    };

    var collapsible = '\n<details><summary>Click to expand</summary>\n' + '\n' + '</details>\n';

    new_startPoint.ch = 0;
    new_startPoint.line += 1;
    new_endPoint.line += 1;

    codemirror.replaceSelection(collapsible);
    codemirror.setSelection(new_startPoint, new_endPoint);
    codemirror.focus();
}

// ------------------------------
// 改變文字大小
// ------------------------------
function changeFontSize(codemirror, fontsize) {

    var startPoint = codemirror.getCursor('start');
    var endPoint = codemirror.getCursor('end');

    var new_startPoint = {
        ch: startPoint.ch,
        line: startPoint.line
    };

    var new_endPoint = {
        ch: endPoint.ch,
        line: endPoint.line
    };

    var text = codemirror.getSelection();

    // var isFirstCh = startPoint.ch === 0;
    var isEmpty = !text;

    if (isEmpty) {
        text = 'enter text here';
        new_endPoint.ch += text.length;
    }

    var before = "(fs>" + fontsize + ":";
    var after = "<fs)";

    new_startPoint.ch += 5 + ('' + fontsize).length; // 調整起始文字select位置 
    // 若是文字在同一行，調整 select 順序
    if (new_startPoint.line === new_endPoint.line) {
        new_endPoint.ch += 5 + ('' + fontsize).length;
    }

    codemirror.replaceSelection(before + text + after);
    codemirror.setSelection(new_startPoint, new_endPoint);
    codemirror.focus();
}

// ------------------------------
// 改變文字顏色
// ------------------------------
function changeFontColor(codemirror, color) {

    var startPoint = codemirror.getCursor('start');
    var endPoint = codemirror.getCursor('end');

    var new_startPoint = {
        ch: startPoint.ch,
        line: startPoint.line
    };

    var new_endPoint = {
        ch: endPoint.ch,
        line: endPoint.line
    };

    var text = codemirror.getSelection();

    // var isFirstCh = startPoint.ch === 0;
    var isEmpty = !text;

    if (isEmpty) {
        text = 'enter text here';
        new_endPoint.ch += text.length;
    }

    var before = "(fc>" + color + ':';
    var after = "<fc)";

    new_startPoint.ch += 5 + color.length; // 調整起始文字select位置 
    // 若是文字在同一行，調整 select 順序
    if (new_startPoint.line === new_endPoint.line) {
        new_endPoint.ch += 5 + color.length;
    }

    codemirror.replaceSelection(before + text + after);
    codemirror.setSelection(new_startPoint, new_endPoint);
    codemirror.focus();
}

// ------------------------------
// 改變文字顏色
// ------------------------------
function changeTextAlign(codemirror, textalign) {

    var startPoint = codemirror.getCursor('start');
    var endPoint = codemirror.getCursor('end');

    var new_startPoint = {
        ch: startPoint.ch,
        line: startPoint.line
    };

    var new_endPoint = {
        ch: endPoint.ch,
        line: endPoint.line
    };

    var text = codemirror.getSelection();

    // var isFirstCh = startPoint.ch === 0;
    var isEmpty = !text;
    if (isEmpty) {
        text = 'enter text here';
        new_endPoint.ch += text.length;
    }

    var before = "(ta>" + textalign + ':\n';
    var after = "\n<ta)";

    new_startPoint.line += 1;
    new_startPoint.ch = 0;
    new_endPoint.line += 1;

    // new_startPoint.ch += 5 + textalign.length; // 調整起始文字select位置 
    // // 若是文字在同一行，調整 select 順序
    // if(new_startPoint.line === new_endPoint.line) {
    //     new_endPoint.ch += 5 + textalign.length;
    // }

    codemirror.replaceSelection(before + text + after);
    codemirror.setSelection(new_startPoint, new_endPoint);
    codemirror.focus();
}

/*--------------------------
    Export
--------------------------*/
var CodeMirrorUtil = {
    /*--------------------------
        Variable
    --------------------------*/
    FORMAT_TYPE: FORMAT_TYPE, // 支援的 format 按鈕
    CODE_SYNTAX: CODE_SYNTAX, // 支援程式碼
    FONT_SIZE: FONT_SIZE, // 支援的文字大小
    FONT_COLORS: FONT_COLORS, // 支援的文字顏色

    /*--------------------------
        Method
    --------------------------*/
    getCursorState: getCursorState, // 取得游標位置狀態
    applyFormat: applyFormat, // format 格式按鈕按下時
    insertInlineText: insertInlineText, // 加入文字
    insertCodeblock: insertCodeblock, // 加入程式碼
    checkIsSupportCode: checkIsSupportCode, // 是否是支援的程式碼
    startOperation: startOperation, // 開始不記錄操作記錄(undo/redo)
    endOperation: endOperation, // 結束不記錄操作記錄(undo/redo)
    replaceText: replaceText, // 替換編輯器內的文字
    insertLatex: insertLatex, // 加入數學式
    insertTable: insertTable, // 加入表格
    insetCollapsibleSection: insetCollapsibleSection, // 加入可折疊區塊
    changeFontSize: changeFontSize, // 修改文字大小
    changeFontColor: changeFontColor, // 修改文字顏色
    changeTextAlign: changeTextAlign // 修改文字對齊
};

exports.default = CodeMirrorUtil;
module.exports = exports['default'];